export const collaborationSetup = {
  junior: {
    workflows: [
      { name: 'Daily Standups', description: 'Share testing progress, blockers, and test results', frequency: 'Daily at 9 AM' },
      { name: 'Test Planning', description: 'Participate in sprint planning and test case reviews', process: 'Review requirements and create test cases' },
      { name: 'Bug Triage', description: 'Participate in bug triage meetings', frequency: 'Bi-weekly' }
    ],
    tools: [
      { name: 'Slack', purpose: 'Team communication', channels: ['#qa-team', '#bug-reports', '#test-automation'] },
      { name: 'JIRA', purpose: 'Bug tracking and test management', access: 'Developer role with QA projects' },
      { name: 'TestRail', purpose: 'Test case management', permissions: 'Test case creation and execution' }
    ],
    processes: [
      { name: 'Test Execution', steps: ['Review test cases', 'Execute manual tests', 'Report bugs', 'Verify fixes'] },
      { name: 'Regression Testing', steps: ['Identify test scope', 'Execute regression suite', 'Report results', 'Update test cases'] }
    ]
  },
  mid: {
    workflows: [
      { name: 'Test Strategy Planning', description: 'Contribute to test strategy and automation planning', frequency: 'Weekly' },
      { name: 'Automation Development', description: 'Develop and maintain test automation frameworks', commitment: 'Lead automation initiatives' },
      { name: 'Cross-team Testing', description: 'Coordinate testing across multiple teams', scope: 'Integration and system testing' }
    ],
    tools: [
      { name: 'Jenkins', purpose: 'CI/CD test integration', access: 'Build and deployment permissions' },
      { name: 'Selenium Grid', purpose: 'Distributed test execution', access: 'Grid configuration and management' },
      { name: 'Allure Reports', purpose: 'Test reporting and analytics', permissions: 'Report generation and analysis' }
    ],
    processes: [
      { name: 'Automation Framework', steps: ['Design framework architecture', 'Implement core components', 'Create test libraries', 'Maintain and enhance'] },
      { name: 'Performance Testing', steps: ['Analyze requirements', 'Design test scenarios', 'Execute load tests', 'Analyze results'] }
    ]
  },
  senior: {
    workflows: [
      { name: 'Quality Strategy', description: 'Define overall quality strategy and standards', responsibility: 'Quality leadership across organization' },
      { name: 'Process Improvement', description: 'Lead quality process improvements', scope: 'Organization-wide quality initiatives' },
      { name: 'Risk Assessment', description: 'Conduct quality risk assessments', impact: 'Product quality and release decisions' }
    ],
    tools: [
      { name: 'Quality Dashboards', purpose: 'Quality metrics and KPIs', role: 'Dashboard design and maintenance' },
      { name: 'Test Management Platforms', purpose: 'Enterprise test management', access: 'Admin permissions across platforms' },
      { name: 'Analytics Tools', purpose: 'Quality analytics and insights', role: 'Data analysis and reporting' }
    ],
    processes: [
      { name: 'Quality Planning', steps: ['Assess quality risks', 'Define quality objectives', 'Plan quality activities', 'Monitor and adjust'] },
      { name: 'Team Development', steps: ['Assess team skills', 'Plan training programs', 'Mentor team members', 'Evaluate progress'] }
    ]
  }
};
